/**
 * Közös formázó segédfüggvények a FE UI-hoz.
 */

/**
 * NUMERIC(n,m) stringet (pl. '365.00000000') letisztít: trailing nullák levágva
 * a tizedesek után, a decimal point is, ha nem marad tizedes.
 *
 * Példák:
 *   '365.00000000' → '365'
 *   '395.50000000' → '395.5'
 *   '0.12340000'   → '0.1234'
 *   '365'          → '365'
 */
export function formatNumericString(raw: string): string {
  if (!raw.includes('.')) return raw;
  const trimmed = raw.replace(/\.?0+$/, '');
  return trimmed === '' || trimmed === '-' ? '0' : trimmed;
}

/**
 * ISO timestamp → 'YYYY-MM-DD HH:mm:ss' (user local time).
 * Ha a string nem érvényes dátum, az eredetit adja vissza.
 */
export function formatTimestamp(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const da = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  const s = String(d.getSeconds()).padStart(2, '0');
  return `${y}-${mo}-${da} ${h}:${mi}:${s}`;
}

/**
 * Date → ISO date string 'YYYY-MM-DD' (user local time).
 */
export function toIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
